import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { getGoogleLoginUrl } from '../../services/authApi';

export const Login: React.FC = () => {
  const { loginWithGoogle } = useAuth();
  const [searchParams] = useSearchParams();

  const oauthError = searchParams.get('error');

  const openInExternalBrowser = () => {
    const url = getGoogleLoginUrl();
    const popup = window.open(url, '_blank', 'noopener,noreferrer');

    if (!popup) {
      window.location.href = url;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Connexion</h1>
        <p className="text-sm text-gray-600 mb-6">
          Connectez-vous avec votre compte Google pour acceder a Travel Optimizer.
        </p>

        {oauthError && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 text-red-700 px-3 py-2 text-sm">
            Echec de la connexion Google. Reessayez.
          </div>
        )}

        <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 text-amber-800 px-3 py-2 text-sm">
          Si Google affiche "The browser you are using does not support JavaScript", ouvrez la connexion
          dans votre navigateur systeme (Chrome, Edge, Firefox).
        </div>

        <button
          type="button"
          onClick={loginWithGoogle}
          className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-gray-900 text-white px-4 py-3 text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Continuer avec Google
        </button>

        <button
          type="button"
          onClick={openInExternalBrowser}
          className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white text-gray-800 px-4 py-3 text-sm font-medium hover:bg-gray-50 transition-colors"
        >
          Ouvrir la connexion dans le navigateur externe
        </button>
      </div>
    </div>
  );
};
